import { createAsyncThunk } from "@reduxjs/toolkit";
import { notificationFail } from "../slices/notificationSlice";
import { setTenantReportList, setLoader, setTenantReportListWithUser } from "../slices/tenantReportSlice";
import { API, graphqlOperation } from "aws-amplify";
import { getTenantReportQuery } from "../../graphql/queries";
import GrafanaClient from "../../config/grafanaClient";
import { setLoader as setGlobalLoader } from "../slices/authSlice";
export const getTenantReportThunk = createAsyncThunk("getTenantReport",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true))
    dispatch(setTenantReportList([]))
    try {
      const postData = (await API.graphql(
        graphqlOperation(getTenantReportQuery, _request)
      )) as { data: any; errors: any[] };
      if (postData.data.getTenantReport) {
        dispatch(setTenantReportList(postData.data.getTenantReport))
      }
      dispatch(setLoader(false))
    } catch (error) {
      dispatch(setLoader(false))
    }
  }
);

//Save User clicks History and logins timess
export const updateUserHistoryData = createAsyncThunk(
  "updateUserHistory", async (_request: any, { dispatch }) => {
    try {
      const data: any = await GrafanaClient().post("/tenant-report/save-tenant-analysis", _request);
    } catch (error) {
      console.log('error', error);
    }
  }
);
// Get Tenants Report with user history
export const getTenantReportNodeThunk = createAsyncThunk(
  "updateUserHistory", async (_request: any, { dispatch }) => {
    try {
      const getHistorydata: any = await GrafanaClient().post("/tenant-report/get-tenant-report", _request);      
      return getHistorydata.data.result;
      // dispatch(setTenantReportListWithUser(getHistorydata.data.result))
    } catch (error) {
      console.log('error', error);
    }
  }
);


export const getUserUsageHistory = createAsyncThunk('getUserUsageHistory', async (_request: { tenantId: string, username: string; fromDate: number; toDate: number }, { dispatch, rejectWithValue }) => {
  try {
    dispatch(setGlobalLoader(true));
    const response = await GrafanaClient().post("tenant-report/get-user-tenant-report", _request);
    dispatch(setGlobalLoader(false));
    if (response?.data) {
      return response?.data;
    }
    rejectWithValue([]);
  } catch (err: any) {
    console.log(err?.message);
    dispatch(setGlobalLoader(false));
    rejectWithValue([]);
  }
})